import {
  AddGroupMemberRequest,
  CreateGroupRequest,
  Group,
  GroupMember,
  MyGroupMembership,
  UpdateGroupMemberRequest,
  UpdateGroupRequest,
} from "@/types/breeze/Group";
import { BaseService } from "../BaseService";

export class GroupService extends BaseService {
  public async listGroups(): Promise<Group[]> {
    return this.getRequest(`/groups`);
  }

  public async listGroupsForUser(userId: number): Promise<Group[]> {
    return this.getRequest(`/groups/by-user/${userId}`);
  }

  public async listMyMemberships(): Promise<MyGroupMembership[]> {
    return this.getRequest(`/groups/mine`);
  }

  public async getGroup(id: number): Promise<Group> {
    return this.getRequest(`/groups/${id}`);
  }

  public async createGroup(request: CreateGroupRequest): Promise<Group> {
    return this.postRequest(`/groups`, request, "Group created");
  }

  public async updateGroup(
    id: number,
    request: UpdateGroupRequest,
  ): Promise<Group> {
    return this.putRequest(`/groups/${id}`, request, "Group updated");
  }

  public async deleteGroup(id: number): Promise<void> {
    return this.deleteRequest(`/groups/${id}`, "Group deleted");
  }

  public async listMembers(groupId: number): Promise<GroupMember[]> {
    return this.getRequest(`/groups/${groupId}/members`);
  }

  public async addMember(
    groupId: number,
    request: AddGroupMemberRequest,
  ): Promise<GroupMember> {
    return this.postRequest(
      `/groups/${groupId}/members`,
      request,
      "Member added",
    );
  }

  public async updateMember(
    groupId: number,
    memberId: number,
    request: UpdateGroupMemberRequest,
  ): Promise<GroupMember> {
    return this.putRequest(
      `/groups/${groupId}/members/${memberId}`,
      request,
      "Member updated",
    );
  }

  public async removeMember(groupId: number, memberId: number): Promise<void> {
    return this.deleteRequest(
      `/groups/${groupId}/members/${memberId}`,
      "Member removed",
    );
  }
}

export const groupService = new GroupService();
